import { Box, Button, Modal } from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";

let style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '95%',
    //'minHeight': '800px',
    minWidth: '400px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
};

const BasePopup = (props: any) => {
    const [stylePage, setStylePage] = useState<any>();
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();
    const buttonTitle = props.buttonTitle ?? (props.isPesquisa ? 'Salvar' : 'Novo');
    
    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    const handleClose = async () => {
        try {
            if (props.confirmClose ?? false) {
                await confirm({ title: "Deseja realmente cancelar?" });
            }

            props.onClose();
        } catch (error) {
            
        }
    };

    useEffect(() => {
        document.body.style.cursor = "default";
    }, [props.isOpen]);

    useEffect(() => {
        if (props.size == "md") {
            style.width = '50%';
            style.height = '50%';
        }
        else {
            style.width = '90%';
            style.height = '95%';
        }

        if(props.height) {
            style.height = props.height;
        }
        
        setStylePage(style);
    }, [props.size]);


    async function onClickFirstButton() {
        try {
            if (!validate()) {
                return;
            }

            document.body.style.cursor = "wait";
            props.onClickFirstButtonPopupCallback();
        } catch (error) {
            console.log(error);
            enqueueSnackbar('Erro ao salvar!', { variant: 'error' });
        }
        finally {
            document.body.style.cursor = "default";
        }
    }

    function validate() {
        let valid = true;
        let inputs = document.querySelectorAll('form input[required]')
        inputs.forEach(element => {
            if (element.attributes.getNamedItem('value')?.value == '') {
                valid = false;
                return;
            }
        });

        if (!valid) {
            enqueueSnackbar('Preencha todos os campo obrigátórios', { variant: 'error' });
        }

        return valid;
    }

    return (
        <Modal
            open={props.isOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={stylePage} className={preferences.darkMode ? "bg-dark" : ""} >
                <div className={"popup-modal-title d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"+(preferences.darkMode ? " bg-dark" : "")}>
                    <h1 className="h2" style={{color: (preferences.darkMode ? 'white' : 'black')}}>{props.title}</h1>
                    <span>
                        {props.hideButtonNew ? '' : 
                        <Button variant="contained" color="info" onClick={onClickFirstButton} style={{ marginTop: 10, float: "left" }}>{buttonTitle}</Button>}
                        <Button variant="outlined" color="info" onClick={handleClose} style={{ marginTop: 10, float: "left" }}>Cancelar</Button>
                    </span>
                </div>

                <div>
                    {props.children}
                </div>
            </Box>
        </Modal>
    );
}

export default BasePopup;